import { cx, css } from '@eti/styles';
import { useProperty, useTranslation } from '@eti/providers';

// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { isEnabled as isModalEnabled } from '../../common/utils/modal';
import { formatGet, formatSet } from '../utils/format';
import ToggleBar from '../containers/ToggleBarContainer';
import { getHighlightedButtonClass, singleChoiceOptionClass } from '../../common/utils/styles';
import AncillaryToggleBar from '../containers/AncillaryToggleBarContainer';
import { jsx as _jsx } from "react/jsx-runtime";
const getOption = (productName, selectedValue, label, value, isNeutral) => ({
  className: cx(singleChoiceOptionClass, !isNeutral && getHighlightedButtonClass(selectedValue, value)),
  dataTestId: `${productName}--${value}`,
  id: `${productName}_${value}`,
  label,
  value
});
const getAncillaryRadioOption = (productName, label, value) => ({
  'data-testid': `${productName}--${value}`,
  id: `${productName}_${value}`,
  label,
  value
});
const oldDesignWrapper = css`
  grid-column: 1 / 3;
  grid-row: 2;
`;
const SingleChoiceToggleBar = ({
  className,
  confirmation,
  form,
  isNeutral,
  isSelected,
  labelNo,
  labelYes,
  persuasion,
  priceRaw,
  productName,
  productPosition,
  rootElement,
  setConfirmationIsOpen,
  setConfirmationOnConfirm,
  setConfirmationOnDecline,
  setPersuasionIsOpen,
  setPersuasionOnConfirm,
  setPersuasionOnDecline,
  travelers
}) => {
  const {
    p
  } = useProperty();
  const {
    t
  } = useTranslation();
  const isNewCardDesignEnabled = p('IbeClient.AncillaryCardV2.Card.Enabled');
  const ancillaryRadioLabelNo = t('Product.AncillaryRadio.Label.No');
  const ancillaryRadioLabelYes = t('Product.AncillaryRadio.Label.Yes');
  return !isNewCardDesignEnabled ? /*#__PURE__*/_jsx(ToggleBar, {
    className: cx(oldDesignWrapper, className),
    form: form,
    formatGet: formatGet,
    formatSet: formatSet(priceRaw),
    inputName: productName,
    isConfirmationEnabled: isModalEnabled(confirmation),
    isNeutral: isNeutral,
    name: "value",
    options: [getOption(productName, isSelected, labelNo, false, isNeutral), getOption(productName, isSelected, labelYes, true, isNeutral)],
    persuasionEnabled: isModalEnabled(persuasion),
    priceRaw: priceRaw,
    setConfirmationIsOpen: setConfirmationIsOpen,
    setConfirmationOnConfirm: setConfirmationOnConfirm,
    setConfirmationOnDecline: setConfirmationOnDecline,
    setPersuasionIsOpen: setPersuasionIsOpen,
    setPersuasionOnConfirm: setPersuasionOnConfirm,
    setPersuasionOnDecline: setPersuasionOnDecline,
    size: "large",
    validationRuleName: productName
  }) : /*#__PURE__*/_jsx(AncillaryToggleBar, {
    form: form,
    formatGet: formatGet,
    formatSet: formatSet(priceRaw),
    inputName: productName,
    isConfirmationEnabled: isModalEnabled(confirmation),
    name: "value",
    options: [getAncillaryRadioOption(productName, ancillaryRadioLabelNo, 'false'), getAncillaryRadioOption(productName, ancillaryRadioLabelYes, 'true')],
    persuasionEnabled: isModalEnabled(persuasion),
    priceRaw: priceRaw,
    productPosition: productPosition,
    rootElement: rootElement,
    setConfirmationIsOpen: setConfirmationIsOpen,
    setConfirmationOnConfirm: setConfirmationOnConfirm,
    setConfirmationOnDecline: setConfirmationOnDecline,
    setPersuasionIsOpen: setPersuasionIsOpen,
    setPersuasionOnConfirm: setPersuasionOnConfirm,
    setPersuasionOnDecline: setPersuasionOnDecline,
    size: "large",
    travelers: travelers,
    validationRuleName: productName
  });
};
export default SingleChoiceToggleBar;
//# sourceMappingURL=SingleChoiceToggleBar.js.map